const Ajax = require('common/infra/ajax');

class API {
    getProject(projectId) {
        return Ajax.GET(`/api/projects/${projectId}`);
    }

    getProjectRoles(groupID) {
        return Ajax.GET(`/api/groups/${groupID}/project-roles`);
    }

    getProjectRole(groupID, roleID) {
        return Ajax.GET(`/api/groups/${groupID}/project-roles/${roleID}`);

    }

    create(groupId, projectJson) {
        return Ajax.POST(`/api/groups/${groupId}/projects`, projectJson);
    }

    update(projectId, projectJson) {
        return Ajax.PUT(`/api/projects/${projectId}`, projectJson)
    }

    delete(projectId) {
        return Ajax.DELETE(`/api/projects/${projectId}`)
    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./common/infra/api/project.js